import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS } from "@contentful/rich-text-types";
import React from 'react';
import { useIntl } from 'react-intl';
import './banner-advice.scss';
import useBrowserMode from "../../../shared/hooks/useBrowserMode";

const BannerAdvice = props => {

    const { locale } = useIntl();
    const { isBrowser } = useBrowserMode()

    const options = {
        renderNode: {
            [BLOCKS.HEADING_1]: (node, next) => <h1 className="f-free-sample-title">{next}</h1>,
            [BLOCKS.EMBEDDED_ASSET]: (node, next) => <>{ isBrowser && <img className="f-free-sample-image" src={node.data.target.fields.file[locale].url} alt={node.data.target.fields.description[locale]} />}</>,
            [BLOCKS.PARAGRAPH]: (node, next) => <p className="f-free-sample-description" >{next}</p>
        }
    };

    return (
        <section className="f-free-sample" >
            <div className="f-free-sample-container" >{documentToReactComponents(props.json, options)}</div>
            <div className="f-free-sample-footer"  >Selecciona el producto que deseas conocer</div>
        </section>
    )
}

export default BannerAdvice;
